import {isFunction} from 'lodash/fp';

import {EVENT_NAMES} from '/enum/tealium.enum';
import {getTealiumUtilDefaultInstance} from '/util/tealium';

const mapping: {[key: string]: string} = {
  // Filter Types
  all: 'all',
  noClients: 'no_clients',
  one_two_newQualifiedClient: '1_2_new_qualified_clients',
  three_four_newQualifiedClient: '3_4_qualified_clients',
  five_six_newQualifiedClient: '5_6_qualified_clients',
  seven_nine_newQualifiedClient: '7_9_qualified_clients',
  ten_plus_newQualifiedClient: '10+_qualified_clients',

  // Filter Types for My Teams Report
  frontline: 'frontline',
  ranks: 'ranks',
  newCoach: 'new_coach',
  fibc: 'fibc',

  // Report Names

  REPORT_ELIGIBLE_CLIENT_SUPPORT_ONE_TWO: 'csb+_1_2_new_clients',
  REPORT_ELIGIBLE_CLIENT_SUPPORT_THREE_FOUR: 'csb+_3_4_new_clients',
  REPORT_ELIGIBLE_CLIENT_SUPPORT_FIVE_SIX: 'csb+_5_6_new_clients',
  REPORT_ELIGIBLE_CLIENT_SUPPORT_SEVEN_NINE: 'csb+_7_9_new_clients',

  // Report Names for My Teams Report
  my_teams_report: 'my_teams_report',

  // SELECTED_FILTERS for My Teams Report
  RANK: 'rank',
  NEWCOACH: 'new_coach',
  FIBC: 'fibc',
};

// Common function to handle both filter types and report names
const mapToTealiumValue = (input: string): string => {
  return mapping[input] || input;
};

export function generateOnPress({
  filterParam,
  setSelectedFilterParam,
  goBack,
  recordsName,
  isApplyAction = false, //  if it's 'Apply' action
  highestRankDescription,
  paidAsRankDescLastMonth,
  filterType,
  userId,
}: any) {
  return () => {
    setSelectedFilterParam({
      recordsName,
      param: filterParam,
    });

    // If it's Apply, navigate back only for 'SEARCH' reports
    if (isApplyAction && recordsName === 'SEARCH' && isFunction(goBack)) {
      goBack();
    }

    // If it's NOT Apply, navigate back immediately for non-'SEARCH' reports
    if (!isApplyAction && recordsName !== 'SEARCH' && isFunction(goBack)) {
      const coachIdStr = userId.toString();
      sendFilterEvent({
        filterType: mapToTealiumValue(filterType),
        reportName: 'client_support_bonus',
        currentScreenName: mapToTealiumValue(recordsName),
        highestAchievedRank: highestRankDescription || 'na',
        lastPaidRank: paidAsRankDescLastMonth || 'na',
        coachId: coachIdStr,
        coachCurrentRank: highestRankDescription || 'na',
        filterSelected: filterParam,
      });
      goBack();
    }
  };
}

const sendFilterEvent = getTealiumUtilDefaultInstance().generateTrackEvent({
  eventName: EVENT_NAMES.onReportFilterPress,
});
